import CryptoJS from 'crypto-js'
import { localStorage as local } from '@entrata/utils'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'


const SECRET_KEY = process.env.RP_SD_SECRET_KEY || 'tp-sd-encryption-key-v1'
const { isTP } = getProjectConditions()

const getSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch (e) {
    console.error('Session storage is not available:', e);
    return {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {}
    };
  }
};

export const setEncryptedCryptoData = (key, data) => {
  const storage = getSessionStorage();
  if (isTP) {
    storage.setItem(
      key,
      CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY)?.toString(),
    );
  } else {
    local.set(
      key,
      CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY)?.toString(),
    )
  }
}

export const getDecryptedCryptoData = key => {
  let encryptedData;
  if (isTP) {
    const storage = getSessionStorage();
    encryptedData = storage.getItem(key);
  } else {
    encryptedData = local.get(key);
  }
  
  const stringifyData =
    (encryptedData &&
      CryptoJS.AES.decrypt(encryptedData, SECRET_KEY)?.toString(
        CryptoJS.enc.Utf8,
      )) ??
    ''
  return (stringifyData && JSON.parse(stringifyData)) ?? ''
}

export const getDecryptedAES256CBCToken = (encrypted_token, token_iv) => {
  return CryptoJS.AES.decrypt(
    encrypted_token,
    CryptoJS.enc.Utf8.parse(process.env.RP_TOKEN_SECRET_KEY),
    {
      iv: CryptoJS.enc.Utf8.parse(token_iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  )?.toString(CryptoJS.enc.Utf8)
}

export const getEncryptedAES256CBCToken = (token, token_iv) =>
  CryptoJS.AES.encrypt(
    token,
    CryptoJS.enc.Utf8.parse(process.env.RP_TOKEN_SECRET_KEY),
    {
      iv: CryptoJS.enc.Utf8.parse(token_iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  )?.toString()
